import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, userProfile, loading, profileLoading } = useAuth();
  const location = useLocation();

  if (loading || profileLoading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'var(--color-background)' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--color-primary)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ animation: 'spin 0.8s linear infinite' }}>
            <path d="M21 12a9 9 0 1 1-6.219-8.56" />
          </svg>
          <span style={{ fontFamily: 'var(--font-caption)', color: 'var(--color-muted-foreground)', fontSize: '0.875rem' }}>Verificando sesión...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Only block if profile is loaded AND status is not ACTIVE
  if (userProfile && userProfile?.status && userProfile?.status !== 'ACTIVE') {
    return <Navigate to="/login" replace />;
  }

  // Only check roles when profile is fully loaded (not null)
  // If profile is null but user is authenticated, allow through — profile may still be auto-creating
  if (userProfile && allowedRoles && allowedRoles?.length > 0) {
    const role = userProfile?.role;
    if (!role || !allowedRoles?.includes(role)) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return children;
};

export default PrivateRoute;
